export function getFromSnake (obj, snakeKey) {
  if (!obj) return null

  const camelKey = snakeKey.replace(/_([a-z])/g, (_, c) => c.toUpperCase())

  if (obj[camelKey] !== undefined) {
    return obj[camelKey]
  }

  if (obj[snakeKey] !== undefined) {
    return obj[snakeKey]
  }

  if (process.env.NODE_ENV === 'development') {
    console.table(`🚨 MAPPING DTO (DEV ONLY)\n\nNi "${camelKey}" ni "${snakeKey}" n'existent sur l'objet.`)
  }

  console.warn(`[Mapping Fallback] "${camelKey}" and "${snakeKey}" are missing.`)
  return null
}
